export default __webpack_public_path__ + "static/media/002-aerial.2b383ea1.png";